<template>
  <section class="c-section c-section--login py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-7">
          <div class="bg-white br--medium p-4 py-5">
            <h1 class="mb-4 text-center darks fs-21 w-bold">
              {{(authType == 'register') ? 'Regístrate' : 'Iniciar sesión'}}
            </h1>
            <div class="mb-4">
              <div class="row gx-4 gy-4">
                <div class="col col-12 col-md-6">
                  <button
                    @click="signOnMedia('facebook')"
                    class="c-button c-button--facebook small d-flex h-100
                      w-100 align-items-center justify-content-center mx-1"
                  >
                    <i class="icon-facebook d-flex align-items-center fs-18"></i>
                    <span class="ms-2">Facebook</span>
                  </button>
                </div>
                <div class="col col-12 col-md-6">
                  <button
                    @click="signOnMedia('google')"
                    class="c-button c-button--google small d-flex h-100
                      w-100 align-items-center justify-content-center mx-1"
                  >
                    <img src="@/assets/images/icons/google.svg" />
                    <span class="ms-2">Google</span>
                  </button>
                </div>
              </div>
            </div>

            <p class="c-hr-text c-hr-text--light mb-0 w-sbold dark-gray text-center mb-4">
              <span class="c-hr-text__content">
                {{
                  (authType == 'register')
                    ? 'o regístrate con tu email'
                    : 'o inicia con tu usuario/email'
                }}
              </span>
            </p>

            <div
              v-if="alert"
              class="c-card-alert p-3 mb-4 text-center"
              :class="`c-card-alert--${alert.type}`"
            >
              {{alert.message}}
            </div>

            <template v-if="authType === 'login'">
              <form
                class="c-form c-form--ghost mb-5"
                @submit.prevent="submitLogin()"
              >
                <div class="row mb-4">
                  <div
                    class="c-form-group col-12 col-lg-12 mb-4"
                    :class="{'c-form-group--error': $v.login.username.$error}"
                  >
                    <input
                      type="text"
                      name="username_login"
                      class="c-form__input w-100"
                      placeholder="Usuario o correo electrónico"
                      v-model.trim="$v.login.username.$model"
                      @keyup.enter="submitLogin()"
                    />

                    <span class="c-form__error" v-if="!$v.login.username.required">
                      El usuario o correo estan vacíos
                    </span>
                  </div>
                  <div
                    class="c-form-group col-12 col-lg-12"
                    :class="{'c-form-group--error': $v.login.password.$error}"
                  >
                    <input
                      type="password"
                      name="password_login"
                      class="c-form__input w-100"
                      placeholder="Contraseña"
                      v-model.trim="$v.login.password.$model"
                      @keyup.enter="submitLogin()"
                    />

                    <span class="c-form__error" v-if="!$v.login.password.required">
                      La contraseña esta vacía
                    </span>
                  </div>
                </div>

                <h2 class="fs-16 text-center mb-4">
                  <router-link to="/olvidaste-contrasena/" class="c-link">
                    ¿Olvidaste tu contraseña?
                  </router-link>
                </h2>

                <button
                  type="submit"
                  class="c-button c-button--primary w-100"
                  :class="{'loading': isLoading}"
                  :disabled="isLoading"
                >
                  Conectarse
                  <img class="c-button__spinner" src="@/assets/images/animations/spinner-white.png">
                </button>
              </form>
            </template>
            <template v-else>
              <form
                class="c-form c-form--ghost mb-3"
                @submit.prevent="submitRegister()"
              >
                <div class="row mb-4">
                  <div
                    class="c-form-group col-12 col-lg-6 mb-4"
                    :class="{'c-form-group--error': $v.register.firstname.$error}"
                  >
                    <input
                      type="text"
                      class="c-form__input w-100"
                      v-model.trim="$v.register.firstname.$model"
                      placeholder="Nombres"
                    />

                    <span
                      class="c-form__error"
                      v-if="!$v.register.firstname.required"
                    >
                      Nombres vacíos
                    </span>
                  </div>

                  <div
                    class="c-form-group col-12 col-lg-6 mb-4"
                    :class="{'c-form-group--error': $v.register.lastname.$error}"
                  >
                    <input
                      type="text"
                      class="c-form__input w-100"
                      v-model.trim="$v.register.lastname.$model"
                      placeholder="Apellidos"
                    />

                    <span class="c-form__error" v-if="!$v.register.lastname.required">
                      Apellidos vacíos
                    </span>
                  </div>

                  <div
                    class="c-form-group col-12 col-lg-6 mb-4"
                    :class="{'c-form-group--error': $v.register.email.$error}"
                  >
                    <input
                      type="email"
                      class="c-form__input w-100"
                      v-model.trim="$v.register.email.$model"
                      placeholder="Correo electrónico"
                    />

                    <div
                      class="c-form__error"
                      v-if="!$v.register.email.required"
                    >
                      E-mail vacío
                    </div>
                    <div
                      class="c-form__error"
                      v-else-if="!$v.register.email.alpha"
                    >
                      E-mail incorrecto
                    </div>
                    <span
                      class="c-form__error"
                      v-else-if="!$v.register.email.isUnique"
                    >
                      Ya existe una cuenta con este correo
                    </span>
                  </div>

                  <div
                    class="c-form-group col-12 col-lg-6 mb-4"
                    :class="{'c-form-group--error': $v.register.username.$error}"
                  >
                    <input
                      type="text"
                      class="c-form__input w-100"
                      v-model.trim="$v.register.username.$model"
                      placeholder="Usuario"
                    />

                    <span
                      class="c-form__error"
                      v-if="!$v.register.username.required"
                    >
                      Nombre de usuario vacío
                    </span>
                    <span
                      class="c-form__error"
                      v-else-if="!$v.register.username.isUnique"
                    >
                      Este usuario ya existe
                    </span>
                  </div>

                  <div
                    class="c-form-group col-12 col-lg-12"
                    :class="{'c-form-group--error': $v.register.password.$error}"
                  >
                    <div class="c-form__password position-relative">
                      <input
                        type="password"
                        class="c-form__input w-100"
                        v-model.trim="$v.register.password.$model"
                        placeholder="Contraseña"
                      />

                      <span
                        class="c-form__error"
                        v-if="!$v.register.password.required"
                      >
                        La contraseña esta vacía
                      </span>
                      <span
                        class="c-form__error"
                        v-if="!$v.register.password.minLength"
                      >
                        La contraseña debe tener minimo
                        {{$v.register.password.$params.minLength.min}}
                        carácteres.
                      </span>
                    </div>
                  </div>
                </div>
                <button
                  class="c-button c-button--primary w-100"
                  :class="{'loading': isLoading}"
                  :disabled="isLoading"
                >
                  Registrarse
                  <img class="c-button__spinner" src="@/assets/images/animations/spinner-white.png">
                </button>
              </form>
            </template>

            <h2
              v-if="authType === 'register'"
              class="fs-16 blacks text-center d-flex justify-content-center align-items-center mb-5"
            >
              Al registrarte estas aceptando estos
              <button
                id="terms-tooltip"
                type="button"
                class="c-link d-flex align-items-center ms-1">
                Términos <i class="d-flex align-items-center iconf-info"></i>
              </button>
            </h2>

            <p class="mb-0 blacks text-center">
              <template v-if="authType === 'login'">
                ¿Aún no eres miembro?
                <router-link to="/registrarse" class="c-link">
                  Registrate
                </router-link>
              </template>
              <template v-else>
                ¿Ya tienes cuenta?
                <router-link to="/ingresar" class="c-link">
                  Iniciar sesión
                </router-link>
              </template>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import {
  required,
  requiredIf,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';
import tippy from 'tippy.js';
import { initFacebookSDK, saveSession } from '../../libs/auth';

export default {
  data() {
    return {
      arcux: {
        ...window.arcux,
      },

      login: {
        username: '',
        password: '',
      },

      register: {
        firstname: '',
        lastname: '',
        email: '',
        username: '',
        password: '',
      },

      isLoading: false,

      alert: null,
    };
  },
  watch: {
    $route() {
      this.initTooltip();
    },
  },
  validations: {
    login: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
    register: {
      firstname: {
        required: requiredIf(function issubmitRegister() {
          return this.authType === 'register';
        }),
      },
      lastname: {
        required: requiredIf(function issubmitRegister() {
          return this.authType === 'register';
        }),
      },
      email: {
        required: requiredIf(function issubmitRegister() {
          return this.authType === 'register';
        }),
        alpha: helpers.regex('alpha', /.+@.+\..+/),
        async isUnique(value) {
          if (value === '') return true;

          const response = await fetch(`${this.arcux.site}/api/v1/auth/validate/email`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              email: value,
            }),
          });

          return Boolean(await response.json());
        },
      },
      username: {
        required,
        async isUnique(value) {
          if (value === '') return true;

          const response = await fetch(`${this.arcux.site}/api/v1/auth/validate/username`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              username: value,
            }),
          });

          return Boolean(await response.json());
        },
      },
      password: {
        required,
        minLength: minLength(5),
      },
    },
  },
  computed: {
    authType() {
      return this.$route.name.toLowerCase();
    },
  },
  mounted() {
    this.initTooltip();
    this.loadScripts();

    this.loadGlobalScripts();

    window.fbq('track', 'ViewContent');

    if (this.$route.query.enroll) {
      window.localStorage.setItem('arcux_query_enroll', this.$route.query.enroll);
    }
  },
  methods: {
    initFacebookSDK,
    initTooltip() {
      const urlTermsConditions = `${window.arcux.site}/terminos-y-condiciones`;
      const urlPrivacyPolicy = `${window.arcux.site}/politica-privacidad`;

      window.setTimeout(() => {
        tippy('#terms-tooltip', {
          content: `<p class="c-tooltip">
            Certifico que tengo 16 años o más y acepto las
            <a href="${urlTermsConditions}" target="_blank">condiciones de uso</a>,
            <a href="${urlPrivacyPolicy}" target="_blank">políticas de privacidad</a> y recibir novedades y promociones.
          </p>`,
          allowHTML: true,
          theme: 'light',
          animation: 'scale',
          inertia: true,
          trigger: 'click',
          interactive: true,
        });
      }, 2000);
    },

    isEmail(email) {
      const regex = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

      return regex.test(email);
    },
    submitLogin() {
      this.$v.$touch();

      if (!this.$v.login.$invalid) {
        this.isLoading = true;

        const url = `${this.arcux.site}/api/v1/auth/login/`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.isEmail(this.login.username) ? this.login.username : '',
            username: this.login.username,
            password: this.login.password,
          }),
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((data) => {
            if (!data.success) {
              throw data;
            }

            this.alert = {
              type: 'success',
              message: `Hola ${data.first_name}, bienvenido nuevamente`,
            };

            saveSession(data.token);

            setTimeout(() => {
              this.goNext();
            }, 3000);
          })
          .catch(this.handleError);
      }
    },
    submitRegister() {
      this.$v.$touch();

      if (!this.$v.register.$invalid) {
        this.isLoading = true;

        const url = `${this.arcux.site}/api/v1/auth/register/`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            first_name: this.register.firstname,
            last_name: this.register.lastname,
            email: this.register.email,
            username: this.register.username,
            password: this.register.password,
          }),
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((data) => {
            if (!data.success) {
              throw data;
            }

            this.alert = {
              type: 'success',
              message: 'Bienvenid@! Por favor verifique su correo para continuar el proceso.',
            };

            saveSession(data.token);

            setTimeout(() => {
              this.goNext();
            }, 3000);
          })
          .catch(this.handleError);
      }
    },

    signOnMedia(social) {
      const authType = (this.authType === 'register')
        ? 'registro'
        : 'login';

      if (social === 'google') {
        this.authWithGoogle(authType);
      } else {
        this.isLoading = true;

        FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
            const token = response.authResponse.accessToken;

            this.handleFacebookAuth(authType, token);
          } else if (response.status === 'authorization_expired') {
            FB.login((response) => {
              if (response.authResponse) {
                const token = response.authResponse.accessToken;

                this.handleFacebookAuth(authType, token);
              } else {
                this.isLoading = false;
              }
            }, { scope: 'public_profile,email', auth_type: 'reauthorize' });
          } else {
            FB.login((response) => {
              if (response.authResponse) {
                this.handleFacebookAuth(authType, response.authResponse.accessToken);
              } else {
                this.handleError({
                  message: 'No se ha podido completar el proceso.',
                });
              }
            }, { scope: 'public_profile,email' });
          }
        });
      }
    },
    authWithGoogle(type) {
      this.isLoading = true;

      if (type === 'login') {
        gapi.load('auth2', () => {
          const auth2 = gapi.auth2.init({
            client_id: this.arcux.project.social.google_app_id,
            fetch_basic_profile: true,
            scope: 'profile',
          });

          auth2.signIn().then((user) => {
            const idToken = user.getAuthResponse().id_token;
            const url = `${this.arcux.site}/api/v1/auth/socials/google`;

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: idToken,
                authType: type,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                if (!data.status) {
                  throw data;
                }

                saveSession(data.token);

                this.goNext();
              }).catch(this.handleError);
          }, (err) => {
            let errorMessage = '';

            if (err.error === 'popup_closed_by_user') {
              errorMessage = 'No se ha podido completar la operacion';
            } else {
              errorMessage = (err.error === 'access_denied')
                ? 'No se ha autorizado la operación, vuelve a intentarlo'
                : 'Ha ocurrido un error, intentado nuevamente en unos minutos';
            }

            this.handleError({
              message: errorMessage,
            });
          });
        });
      } else {
        gapi.load('auth2', () => {
          const auth2 = gapi.auth2.init({
            client_id: this.arcux.project.social.google_app_id,
            fetch_basic_profile: true,
            scope: 'profile',
          });

          auth2.signIn().then((user) => {
            const idToken = user.getAuthResponse().id_token;
            const url = `${this.arcux.site}/api/v1/auth/socials/google`;

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                token: idToken,
                authType: type,
              }),
            })
              .then((res) => res.json())
              .then((data) => {
                if (!data.status) {
                  throw data;
                }

                saveSession(data.token);

                this.goNext();
              }).catch(this.handleError);
          }, (err) => {
            let errorMessage = '';

            if (err.error === 'popup_closed_by_user') {
              errorMessage = 'No se ha podido completar la operacion';
            } else {
              errorMessage = (err.error === 'access_denied')
                ? 'No se ha autorizado la operación, vuelve a intentarlo'
                : 'Ha ocurrido un error, intentado nuevamente en unos minutos';
            }

            this.handleError({
              message: errorMessage,
            });
          });
        });
      }
    },

    handleFacebookAuth(authType, token) {
      FB.api('/me', { fields: 'id, name, first_name, last_name, email, locale' }, (userData) => {
        this.authWithFacebook(authType, {
          id: userData.id,
          email: userData.email,
          name: userData.name,
          first_name: userData.first_name,
          last_name: userData.last_name,
        }, token);
      })
    },
    authWithFacebook(type, user, FBtoken) {
      const url = `${this.arcux.site}/api/v1/auth/socials/facebook`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token: FBtoken,
          authType: type,
          uuid: user.id,
          name: user.name,
          firstName: user.first_name,
          lastName: user.last_name,
          email: user.email,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (!data.status) {
            throw data;
          }

          saveSession(data.token);

          this.goNext();
        }).catch(this.handleError);
    },

    handleError(error) {
      let errorMessage = '';

      try {
        errorMessage = JSON.parse(error.message)?.message;
      } catch (err) {
        errorMessage = error.message;
      }

      this.alert = {
        type: 'error',
        message: errorMessage,
      };

      this.isLoading = false;

      setTimeout(() => {
        this.alert = null;
      }, 5000);
    },
    goNext() {
      const storageBackURL = window.localStorage.getItem('arcux_back_url');
      const queryBackURL = this.$route.query.back_url;
      const finalBackURL = queryBackURL ? queryBackURL : storageBackURL;
      const queryEnroll = window.localStorage.getItem('arcux_query_enroll');

      if (queryEnroll) {
        window.localStorage.removeItem('arcux_back_url');
        window.localStorage.removeItem('arcux_query_enroll');
        window.location.href = `${process.env.VUE_APP_SITE}/panel/curso/${queryEnroll}/enrollment/gratis`;
      } else if (finalBackURL) {
        let queries = '';

        if (this.$route.query.plan) {
          queries += `&plan=${this.$route.query.plan}`;
        }

        window.localStorage.removeItem('arcux_back_url');
        window.location = `${finalBackURL}${queries}`;
      } else {
        this.$router.go('/');
      }
    },

    loadScripts() {
      const googleScript = document.createElement('script');

      googleScript.setAttribute('src', 'https://apis.google.com/js/platform.js');

      document.head.appendChild(googleScript);

      this.initFacebookSDK();
    },
  },
};
</script>
